// extracted by mini-css-extract-plugin
module.exports = {"base":"src-TaskWindowFooter-base-cc3d6ad9"};